class VersionInfoOpener extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.modal = document.querySelector(this.getAttribute('data-modal'));
    if (!this.button || !this.modal || typeof this.modal.show !== 'function') return;

    this.handleClick = () => this.modal.show(this.button);
    this.syncExpandedState = () => {
      this.button.setAttribute('aria-expanded', String(this.modal.hasAttribute('open')));
    };

    this.button.addEventListener('click', this.handleClick);
    this.modalObserver = new MutationObserver(this.syncExpandedState);
    this.modalObserver.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
    this.syncExpandedState();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    this.modalObserver?.disconnect();
  }
}

if (!customElements.get('version-info-opener')) {
  customElements.define('version-info-opener', VersionInfoOpener);
}
